import React from "react";
import rainbowAndCloudSvg from "../imgs/cloudandrainbow.svg";

export default function RainbowAndCloud() {
  return <img src={rainbowAndCloudSvg} alt="rainbow and cloud"/>
}
